<template>
    <div>
      <v-dialog v-model="bCargando"  hide-overlay persistent width="500">
      <v-card
        class="text-center"
        color="primary"
        dark>
        <v-card-text class="text-center pa-1">
          <p class="lh-base pa-2">
            {{ sLabel }}
          </p>
          <div
            v-if="nAvanceGeneral<100"
            style="height: 90px;"
          >
            <fulfilling-bouncing-circle-spinner
              :animation-duration="4000"
              :size="40"
              color='white'
              class="mx-auto"
            />
            <p class="lh-base py-4">
              {{ Math.floor(nAvanceGeneral *100) / 100 }} %
          </p>
            
          </div>
        </v-card-text>
      </v-card>
      </v-dialog>
    </div>
</template>

<script>
import { FulfillingBouncingCircleSpinner } from 'epic-spinners'
export default {
    name: 'ModalCargando',
    components: {
    FulfillingBouncingCircleSpinner
    },
    props: {
        sLabel: {
            type: String,
            default: "Cargando Sedes ..."
        },
        nAvanceGeneral: {
            type: Number,
            default: 0
        },
        bCargando:{
            type: Boolean,
            default: true
        }
    }

}
</script>